<template>
  <div>
    <ts-card-wrapper>
      <div class="d-flex justify-content-end">
        <div class="d-flex">
          <ts-input
            v-model="search"
            v-tooltip="$t('expenseCategory.search')"
            :placeholder="$t('search')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
      </div>
    </ts-card-wrapper>
    <Table
      :columns="columns"
      :data="resources"
      size="small"
      :loading="loading"
      max-height="700"
    >
      <template slot-scope="{ row }" slot="is_assigned">
        <Icon
          v-if="row.is_assigned"
          type="ios-checkmark-circle-outline text-success"
          size="20"
        />
        <Icon v-else type="ios-close-circle-outline text-danger" size="20" />
      </template>
    </Table>
    <ts-card-wrapper>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'assignedIndex',
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('report/productAddonInfo', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.report.productAddonInfo.search
      },
      set (newValue) {
        this.$store.commit('report/productAddonInfo/SET_SEARCH', newValue)
        this.$store.commit('report/productAddonInfo/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('productAddonInfo.category'),
          key: 'category',
          sortable: false,
          width: 150
        },
        {
          title: this.$t('productAddonInfo.barcode'),
          key: 'barcode',
          sortable: false,
          align: 'center',
          width: 150
        },
        {
          title: this.$t('productAddonInfo.productNameEn'),
          key: 'product_name_en',
          sortable: false
        },
        {
          title: this.$t('productAddonInfo.productNameKh'),
          key: 'product_name_kh',
          sortable: false
        },
        {
          title: this.$t('productAddonInfo.isAssigned'),
          slot: 'is_assigned',
          sortable: false,
          align: 'center',
          width: 130,
          filters: [
            {
              label: 'No',
              value: false
            },
            {
              label: 'Yes',
              value: true
            }
          ],
          filterMultiple: false,
          filterRemote (value) {
            this.fetchData({
              filter: {
                is_assigned: value
              }
            })
          }
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('report/productAddonInfo/fetch', {
          ...attributes
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'Product Addon Info',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('report/productAddonInfo/RESET_STATE')
    next()
  }
}
</script>
